import React, {useState} from 'react';
import {Trans} from 'gatsby-plugin-react-i18next';
import {Products} from '../links/Products';
import {MenuItem, LinkWrapper, TriangleArrow, DropdownMenu} from '../utils/Styled';

export const ProductsSelector: React.FC = () => {
  const [isOpen, setOpen] = useState(false);

  return (
    <MenuItem onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <LinkWrapper>
        <Trans>Products</Trans>
      </LinkWrapper>
      <DropdownMenu visible={isOpen} minWidth="330px" left="-125px" leftMobile="-105px" column>
        <TriangleArrow visible={isOpen} left="calc(30% - 8px)" />
        <Products itemClick={() => setOpen(false)} />
      </DropdownMenu>
    </MenuItem>
  );
};
